import {IDML_LAYERS_EVENTS, idmlLayersEventBroker} from "@frontend/group/modules/idml-layers/event-broker";

export const initIDMLViewer = (files, options = {}) => {
  $('#idml-preview').modal();
  idmlLayersEventBroker.fire(IDML_LAYERS_EVENTS.INIT, {files, ...options});
};
